'use strict';

var formValidation = require('base/components/formValidation');
var location = window.location;
var clientSideValidation = require('../components/common/clientSideValidation');
var util = require('../util');

/**
 * Get cookie value by cookie name from browser
 * @param {string} cookieName - name of the cookie
 * @returns {string} cookie value of the found cookie name
 */
function getCookie(cookieName) {
    var name = cookieName + '=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var cookieArray = decodedCookie.split(';');
    for (var i = 0; i < cookieArray.length; i++) {
        var cookieItem = cookieArray[i];
        while (cookieItem.charAt(0) === ' ') {
            cookieItem = cookieItem.substring(1);
        }
        if (cookieItem.indexOf(name) === 0) {
            return cookieItem.substring(name.length, cookieItem.length);
        }
    }
    return '';
}

/**
 * Delete a cookie by name
 * @param {string} cookieName - name of the cookie
 */
function deleteCookie(cookieName) {
    var d = new Date();
    d.setTime(d.getTime() + (0 * 24 * 60 * 60 * 1000));
    var expires = 'expires=' + d.toGMTString();

    document.cookie = `${cookieName}=false; ${expires}; secure='on'; path=/;`;
}

/**
 * Open login modal
 * @param {Object} $this current element
 */
function getModalHtmlElement() {
    var htmlString = '<!-- Modal -->'
        + '<div class="modal g-modal g-modal-loginform" id="loginModal" role="dialog">'
        + '<div class="modal-dialog g-modal-dialog ">'
        + '<!-- Modal content-->'
        + '<div class="modal-content g-modal-content">'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
}

/**
 * append login form into modal
 * @param {Object} $this current element
 * @param {Object} isPasswordResetOpen do we need to show password reset modal
 */
function openLoginModal($this, isPasswordResetOpen) {
    $.spinner().start();
    $('body').find('.b-loader').css('z-index', '999');
    const { pageRef } = window.GLOBAL_VALUES || {};
    $.ajax({
        url: $('.b-account-history').data('login-url') || $this.data('href') || $this.attr('href'),
        data: { format: 'ajax', pageRef },
        error: function () {
            $.spinner().stop();
        },
        success: function (data) {
            $.spinner().stop();
            $('body').find('.modal-backdrop.show').remove();
            $('#loginModal .g-modal-content').empty();
            $('#loginModal .g-modal-content').html(data);
            $('.g-reset-password-modal').addClass('hide');
            $('.g-force-password-reset-confirm-modal').addClass('hide');
            util.branchCloseJourney();
            $('#loginModal').modal('show');
            $('body').trigger('modalShown', { name: 'login' });
            $('#loginModal').next('.modal-backdrop.show').css('z-index', '999');
            // open password reset popup
            if (isPasswordResetOpen) {
                $('.js-reset-password').trigger('click');
            }
        }
    });
}

/**
 * redirect to auth url
 * @param {Object} $this current element
 */
function redirectToAuthUrl($this) {
    $.spinner().start();
    $('.b-loader').css('z-index', '999');
    const { pageRef } = window.GLOBAL_VALUES || {};
    var params = {
        format: 'ajax',
        pageRef: pageRef
    };
    var url = $this.data('href') || $this.attr('href');
    var windowURL = window.location.href;
    if (windowURL.indexOf('stage=payment') > -1) {
        url = util.appendParamsToUrl(url, { stage: 'payment' });
    }
    var acccountHistory = $('.b-account-history');
    if ($('#checkout-main').length || $('.b-order-confirmation').length || acccountHistory.length) {
        params.redirectAfterLogIn = true;
        if ($('#checkout-main').length) {
            params.rurl = 2;
        }
        if (acccountHistory.length) {
            url = acccountHistory.data('login-url') || url;
        }
    }
    $.ajax({
        url: url,
        data: params,
        complete: function () {
            $.spinner().stop();
        },
        success: function (data) {
            if (data.authUrl) {
                window.location.href = data.authUrl;
            } else {
                console.error('Redirect URL is missing in the response.');
            }
        },
        error: function (xhr) {
            console.error('Error during the request:', xhr.status, xhr.statusText);
        }
    });
}

/**
 * Login event to open login modal
 */
function loginModal() {
    $('body').on('click', '.js-login', function (e, isPasswordResetOpen) { // should be genuinely global
        e.preventDefault();
        $('#loginModal').remove();
        if ($('#newUserRegisterModal').length > 0) {
            $('#newUserRegisterModal').remove();
        }
        if ($(this).closest('.js-register-in-page').length > 0) {
            var registerUrl = $(this).attr('data-href');
            if ($(this).hasClass('b-registration-error-link')) {
                registerUrl = $(this).attr('href');
            }
            window.location.href = registerUrl;
            return false;
        }
        if ($('.js-account-profile-page').length > 0) {
            return false;
        }
        if ($('.b-order_track').length > 0) {
            window.location.href = $('.b-order_track-link a').attr('href');
            return false;
        }
        if ($(this).hasClass('secure-auth-init')) {
            redirectToAuthUrl($(this));
        } else {
            getModalHtmlElement();
            openLoginModal($(this), (typeof isPasswordResetOpen !== 'undefined' && isPasswordResetOpen));
        }
        return true;
    });
}

/**
 * Login event to perform social login
 */
function faceBookLogin() {
    $('body').on('click', '.g-button_facebook', function (e) {
        e.preventDefault();
        var $this = $(e.target);
        // eslint-disable-next-line no-undef
        FB.login(function (response) {
            if (response.status === 'connected') {
                var url = $('.g-button_facebook').attr('href');
                url += '&accessToken=' + response.authResponse.accessToken;
                $.ajax({
                    url: url,
                    type: 'GET',
                    context: $this,
                    success: function (data) {
                        if (!data.success) {
                            $('input[name$=login-oauth-form]').trigger('login:error', data);
                            $('.b-invalid-cred').html(data.error).show();
                        } else {
                            $this.closest('.g-modal').modal('hide');
                            $('input[name$=login-oauth-form]').trigger('login:success', data);
                            location.href = data.redirectUrl;
                        }
                    },
                    error: function (data) {
                        if (data && data.responseJSON && data.responseJSON.redirectUrl) {
                            window.location.href = data.responseJSON.redirectUrl;
                        } else {
                            $('input[name$=login-oauth-form]').trigger('login:error', data);
                        }
                    }
                });
            } else {
                var dataError = $('.g-button_facebook').data('error-msg');
                $('input[name$=login-oauth-form]').trigger('login:failed', {
                    errorMessage: dataError
                });
                $('.b-invalid-cred').html(dataError).show();
            }
        }, { scope: 'email' });
        return false;
    });
}

/**
 * Forgot Password event to toggle forgot password content
 */
function resetPassword() {
    $('body').on('click', '#loginModal .js-reset-password', function (e) {
        e.preventDefault();
        var attributes = e.currentTarget.attributes;
        var isLoyalty = false;
        if (attributes.isLoyalty && attributes.isLoyalty.value) {
            isLoyalty = attributes.isLoyalty.value;
        }
        this.$target = $('.g-reset-password-modal').clone();
        $('#loginModal .g-modal-content').empty();
        $('#loginModal .g-modal-content').append(this.$target);
        if (isLoyalty) {
            var loginURL = $('#loginModal .loyalty-login').attr('href');
            $('#loginModal .loyalty-login').attr('href', loginURL + '?pilotEnroll=' + isLoyalty);
            $('#loginModal #backToLoginButton').attr('href', loginURL + '?pilotEnroll=' + isLoyalty);
        }
        $('.g-reset-password-modal').removeClass('hide');
        $('.g-password-reset-confirm-modal').addClass('hide');
        $('body').trigger('modalShown', { name: 'password-forgot-form' });
    });
}

/**
 * Show the password toggle
 */
function showPassword() {
    $('body').on('click', '.js-show-password', function () {
        var inputField = $(this).parent().find('input');
        var hideLabel = $(this).attr('data-hide');
        var showLabel = $(this).attr('data-show');
        var typee = inputField.attr('type');
        if (typee === 'password') {
            inputField.attr('type', 'text');
            $(this).html(hideLabel);
        } else {
            inputField.attr('type', 'password');
            $(this).html(showLabel);
        }
    });
}

/**
 * Validate the login Inputs
 */
function loginSubmit() {
    $('body').on('click', '#loginModal .js-login-button', function (e) {
        e.preventDefault();
        var form = $(this).closest('form');
        var url = form.attr('action');
        var button = form.find('.js-login-button');
        var buttonContainer = button.parent('div');
        buttonContainer.spinner().start();
        button.css('color', 'transparent');
        button.attr('disabled', 'true');
        clientSideValidation.checkMandatoryField(form);
        if (!form.find('input.is-invalid').length) {
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    button.removeAttr('style');
                    buttonContainer.spinner().stop();
                    if (!data.success && data.error_code === 'ERROR_PASSWORD_RESET_REQUIRED') {
                        button.prop('disabled', false);
                        let resetModal = $('.g-force-password-reset-confirm-modal').clone();
                        $('#loginModal .g-modal-content').empty();
                        $('#loginModal .g-modal-content').append(resetModal);
                        $('.g-force-password-reset-confirm-modal').removeClass('hide');
                    } else if (!data.success) {
                        button.prop('disabled', false);
                        $('form.login').trigger('login:error', data);
                        $('body').trigger('login:failed', {
                            errorMessage: data && data.error && data.error[0]
                        });
                        $('.b-invalid-cred').html(data.error).show();
                    } else {
                        $('form.login').trigger('login:success', data);
                        $('body').trigger('login:success:analytics', {
                            customerNo: data && data.customerNo,
                            email: form.find('[name="loginEmail"]').val()
                        });
                        if ('loyaltyGatedModal' in data) {
                            $('body').trigger('loyalty:enroll', {
                                type: 'genericLink',
                                loyalty: data.loyaltyGatedModal,
                                action: data.loyaltyGatedModal ? 'joined-yes' : 'joined-no',
                                member: 'current_member',
                                points_earned: 0
                            });
                        }
                        // Use redirectUrl if any is provided in the response
                        if (data && data.returnUrl) {
                            location.href = data.returnUrl;
                        } else if ((data && data.redirectUrl && data.shouldRedirect) || $('#checkout-main').length > 0 || $('.b-order-confirmation').length || $('.b-account-history').length || ($('#checkout-main').length > 0 && data.isEmployee) || ($('#checkout-main').length > 0 && data.isVIP) || 'loyaltyGatedModal' in data) {
                            location.href = data.redirectUrl;
                        } else if (data && data.redirectUrl && data.ischeckoutBasketMerge) {
                            location.href = data.redirectUrl;
                        } else {
                            window.location.reload();
                        }
                    }
                },
                error: function (data) {
                    if (data.status === 418 || data.status === 406) {
                        $('.b-invalid-cred').text($('.b-invalid-cred').attr('data-blocked-msg')).show();
                        // Refresh the legacy browser challenge iframe when dynamic challenges are disabled.
                        if (data.getResponseHeader('x-ua-refresh-browser-challenge') && $('iframe.b-footer_challenge').length) {
                            try {
                                $('iframe.b-footer_challenge')[0].contentDocument.location.reload(true);
                            } catch (err) {
                                // swallow error and refresh the page for the user instead of just the iframe - this should really never happen
                                location.reload();
                            }
                        }
                    }
                    if (data && data.responseJSON && data.responseJSON.redirectUrl) {
                        window.location.href = data.responseJSON.redirectUrl;
                    } else {
                        $('form.login').trigger('login:error', data);
                        button.prop('disabled', false);
                        button.removeAttr('style');
                        buttonContainer.spinner().stop();
                    }
                }
            });
        } else {
            button.prop('disabled', false);
            button.removeAttr('style');
            buttonContainer.spinner().stop();
            $('body').trigger('login:failed', {
                emailErrorMessage: $('#form-email-error').text(),
                passwordErrorMessage: $('#form-password-error').text()
            });
        }
        return false;
    });
}

/**
 * Validate the email field and continue to password
 */
function loginContinue() {
    $('body').on('click', '#loginModal .js-continue-button', function (e) {
        e.preventDefault();
        var form = $(this).closest('form');
        clientSideValidation.checkMandatoryField(form);

        if ($('#form-email-error').text() === '') {
            var email = $('#login-form-email').val();
            $('.email-value-show .email-value').text(email);
            $('.before-continue').addClass('d-none');
            $('.after-continue').removeClass('d-none');
        }
    });
}

/**
 * Go back to change email
 */
function loginUseDiffEmail() {
    $('body').on('click', '#loginModal .use-different-email', function (e) {
        e.preventDefault();
        $('.before-continue').removeClass('d-none');
        $('.after-continue').addClass('d-none');
    });
}

/**
 * Go back to change email
 */
function checkoutAsGuest() {
    $('body').on('click', '#loginModal .js-checkoutguest-button', function (e) {
        e.preventDefault();
        $('#loginModal').find('button.close').trigger('click');
    });

    $(document).on('keydown', function (event) {
        if (event.key === 'Escape' && $('.js-checkoutguest-button').length) {
            $('.js-checkoutguest-button').trigger('click');
        }
    });
}

/**
 * Submit the password reset Inputs
 */
function passwordResetSubmit() {
    $('body').on('click', '#loginModal .js-passwordreset-modal', function (e) {
        e.preventDefault();
        var form = $(this).closest('form');
        var url = form.attr('action');
        var button = form.find('.js-passwordreset-modal');
        var buttonContainer = button.parent('div');
        buttonContainer.spinner().start();
        button.css('color', 'transparent');
        button.attr('disabled', 'true');
        clientSideValidation.checkMandatoryField(form);
        if (!form.find('input.is-invalid').length) {
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    button.prop('disabled', false);
                    button.removeAttr('style');
                    buttonContainer.spinner().stop();
                    this.$target = $('.g-password-reset-confirm-modal').clone();
                    $('#loginModal .g-modal-content').empty();
                    $('#loginModal .g-modal-content').append(this.$target);
                    $('body').find('#loginModal .confirm-reset-password-title').html(data.receivedMsgHeading);
                    $('body').find('#loginModal .confirm-password-reset-text').html(data.receivedMsgBody);
                    $('.g-password-reset-confirm-modal').removeClass('hide');
                    if (data.success) {
                        this.$target = $('.g-password-reset-confirm-modal').clone();
                        $('#loginModal .g-modal-content').empty();
                        $('#loginModal .g-modal-content').append(this.$target);
                        $('body').find('#loginModal .confirm-reset-password-title').html(data.receivedMsgHeading);
                        $('body').find('#loginModal .confirm-password-reset-text').html(data.receivedMsgBody);
                        $('body').find('#loginModal .confirm-password-reset-text span').html(data.email);
                        $('#loginModal .g-password-reset-confirm-modal').removeClass('hide');
                        $('body').trigger('modalShown', { name: 'password-forgot-sent' });
                    } else {
                        formValidation(form, data);
                    }
                },
                error: function (err) {
                    console.log(err);
                }
            });
        } else {
            button.prop('disabled', false);
            button.removeAttr('style');
            buttonContainer.spinner().stop();
        }
        return false;
    });
}

/**
 * Open login popup if page redirect from session expire
 */
function openLoginOnPageLoad() {
    if ($('input[name="showLogin"]').val() === 'true') {
        $('.b-header_account-link.js-login').trigger('click');
    }
}

/**
 * Open password reset popup if page redirect from password reset
 */
function openPasswordResetOnPageLoad() {
    if ($('input[name="showPasswordReset"]').val() === 'true') {
        $('.b-header_account-link.js-login').trigger('click', true);
    }
}

/**
 * On updating new password
 */
function updatePasswordSubmit() {
    $('body').on('click', '.js-passwordresetpage-button', function (e) {
        e.preventDefault();
        var form = $(this).closest('form');
        var url = form.attr('action');
        form.spinner().start();
        clientSideValidation.checkMandatoryField(form);
        if (!form.find('input.is-invalid').length) {
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        formValidation(form, data);
                    } else {
                        $('#passwordresetSuccess').modal('show');
                    }
                },
                error: function (err) {
                    console.log(err);
                }
            });
        }
        form.spinner().stop();
        return false;
    });
}

/**
 * On close of reset password pop up
 */
function resetClosePopUp() {
    $('body').on('click', '.js-reset-popup-close', function (e) {
        e.preventDefault();
        var redirectUrl = $(this).attr('data-redirect-url');
        window.location.href = redirectUrl;
    });
}

/**
 * Login event consecutive space validator
 */
function consecutiveSpaceValidator() {
    var counter = 0;
    $('body').on('keydown', '#login-form-email, #login-form-password', function (e) {
        if (e.which === 32 || e.keyCode === 32) {
            counter += 1;
            if (counter > 1) {
                e.preventDefault();
            }
        } else {
            counter = 0;
        }
    });
}

/**
 * Initializes the login analytics handler on DOM ready.
 */
function handleLoginAnalyticsEvent() {
    $(document).ready(function () {
        const cookieName = 'triggerLoginSuccess';
        var interval;
        var timeout;
        var startTime = Date.now();
        var checkCount = 0;

        /**
         * Checks whether Evergage (SalesforceInteractions) has been initialized.
         * @returns {boolean} True if Evergage is ready, otherwise false.
         */
        function isSalesforceInteractionsReady() {
            return (
                window
                && window.SalesforceInteractions
                && typeof window.SalesforceInteractions.getSitemapConfig === 'function'
                && window.SalesforceInteractions.getSitemapConfig().global
                && window.document.readyState === 'complete'
            );
        }

        /**
         * Attempts to trigger the login success event if the cookie is set and Evergage is ready.
         */
        function tryTrigger() {
            if (isSalesforceInteractionsReady()) {
                $('body').trigger('login-callback:success:analytics');
                deleteCookie(cookieName);
                clearInterval(interval);
                clearTimeout(timeout);
            } else {
                var elapsedTime = Date.now() - startTime;
                // After 15s switch to exponential back-off
                if (elapsedTime > 15 * 1000) {
                    checkCount += 1;
                    var backoffTime = Math.min(30 * 60 * 1000, Math.pow(2, checkCount) * 10);
                    clearInterval(interval);
                    interval = setInterval(tryTrigger, backoffTime);
                }
            }
        }

        if (getCookie(cookieName) === 'true') {
            // Poll immediately every 10ms
            interval = setInterval(tryTrigger, 10);

            // Give up after 5 minutes
            timeout = setTimeout(function () {
                clearInterval(interval);
            }, 5 * 60 * 1000);
        }
    });
}

module.exports = {
    loginModal: loginModal,
    loginSubmit: loginSubmit,
    showPassword: showPassword,
    resetPassword: resetPassword,
    passwordResetSubmit: passwordResetSubmit,
    openLoginOnPageLoad: openLoginOnPageLoad,
    openPasswordResetOnPageLoad: openPasswordResetOnPageLoad,
    updatePasswordSubmit: updatePasswordSubmit,
    faceBookLogin: faceBookLogin,
    resetClosePopUp: resetClosePopUp,
    consecutiveSpaceValidator: consecutiveSpaceValidator,
    loginContinue: loginContinue,
    loginUseDiffEmail: loginUseDiffEmail,
    checkoutAsGuest: checkoutAsGuest,
    handleLoginAnalyticsEvent: handleLoginAnalyticsEvent
};
